export default "__VITE_ASSET__D26_7CIT__"